import React, { useEffect, useState } from "react";
// hooks
import { useAppSelector } from "src/hooks";
import { useRouter } from "next/router";
// redux
import { dynamicStateFieldSelector } from "src/redux/slices";
// const
import { DEMO_BLOCK } from "src/constants/dynamic";
import { ICountry } from "src/constants/countries";
// types
import { IDynamicDemo } from "src/types/dynamic/demo/demo";
// utils
import { getCountry } from "src/utils/countries";
// theme
import {
  Wrapper,
  Content,
  TextContainer,
  Text,
  Title,
  SubTitle,
  Container,
  Waves,
} from "./Demo.styles";
import { v4 as uuid } from "uuid";

const Demo = () => {
  const router = useRouter();
  const data = useAppSelector(dynamicStateFieldSelector<IDynamicDemo>(DEMO_BLOCK));
  const [isSuccess, setIsSuccess] = useState(false);

  const userCountry: ICountry = getCountry(router.locale, "locale") as ICountry;

  const pathForm = (): string => {
    let countryFormUrl: string | null = null;
    let defaultFormUrl: string = data?.hubspot_url || "";

    if (userCountry.short_name === "US") countryFormUrl = data?.hubspot_usa_url;
    if (userCountry.short_name === "CA") countryFormUrl = data?.hubspot_ca_url;
    if (userCountry.short_name === "UK") countryFormUrl = data?.hubspot_uk_url;
    if (userCountry.short_name === "IE") countryFormUrl = data?.hubspot_ie_url;

    return countryFormUrl || defaultFormUrl;
  };

  useEffect(() => {
    if (window.localStorage.getItem("bookingId")) {
      return;
    }
    const bookingId = uuid();
    window.localStorage.setItem("bookingId", bookingId);
  }, []);

  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.data.event === "demo_success") {
        setIsSuccess(true);

        const bookingId = window.localStorage.getItem("bookingId");

        if (!bookingId) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "demo_success",
          data: {
            booking_id: bookingId,
          },
        });

        window.localStorage.removeItem("bookingId");
      }
    });
  }, []);

  if (isSuccess) {
    return (
      <Wrapper>
        <Waves />
        <Content>
          <TextContainer>
            <Text>{data?.text}</Text>
            <Title>Meeting scheduled, see you soon! 🚀</Title>
            <SubTitle>An invitation has been sent to your email.</SubTitle>
          </TextContainer>
        </Content>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Waves />
      <Content>
        <Container title="form" src={pathForm()} />
        <TextContainer>
          <Text>{data?.text}</Text>
          <Title>{data?.title}</Title>
          <SubTitle>{data?.sub_title}</SubTitle>
        </TextContainer>
      </Content>
    </Wrapper>
  );
};

export default Demo;
